import { useSelector } from "react-redux";

import LoadingOverlay from "@/components/loading-overlay";
import { selectLoadPanelVisible } from "@/redux/shareSlice";

const Loader = () => {
    const loadPanelVisible: boolean = useSelector(selectLoadPanelVisible);
    return (<>
        {
            loadPanelVisible ? <LoadingOverlay /> : <></>
        }</>
    );
};

export default Loader;